import { Link } from 'react-router-dom';
import { latestMangas } from '@/mocks/manga';

export default function LatestSection() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="flex items-center justify-between mb-8">
        <div>
          <p className="text-xs text-foreground-500 uppercase tracking-widest mb-2">
            LATEST UPDATES
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            最新更新
          </h2>
        </div>
        <Link
          to="/category/all"
          className="hidden sm:flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
        >
          查看更多
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {latestMangas.map((manga) => (
          <Link
            key={manga.id}
            to={`/comic/${manga.id}`}
            className="group flex gap-4 bg-background-100 rounded-xl p-4 cursor-pointer transition-all duration-300 hover:-translate-y-1"
            data-product-shop=""
          >
            <div className="w-20 sm:w-24 flex-shrink-0 rounded-lg overflow-hidden">
              <img
                src={manga.coverImage}
                alt={manga.title}
                title={`${manga.title} - 歪歪漫画网最新章节`}
                className="w-full aspect-[3/4] object-cover object-top"
                loading="lazy"
              />
            </div>
            <div className="flex flex-col justify-between flex-1 min-w-0">
              <div>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
                  {manga.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-2 leading-relaxed">
                  {manga.description}
                </p>
              </div>
              <div className="flex items-center justify-between mt-2">
                <span className="text-xs text-foreground-500">{manga.author}</span>
                <span className="flex items-center gap-1 text-xs text-accent-600">
                  <i className="ri-time-line"></i>
                  {manga.updatedAt}
                </span>
              </div>
              <div className="flex flex-wrap gap-1.5 mt-2">
                {manga.tags.slice(0, 3).map((tag) => (
                  <span
                    key={tag}
                    className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}